<template>
  <button class="btn_share" type="button" @click="openShareSheet" v-if="deviceCanShare">
    Share SKU
  </button>
</template>

<script>
export default {
  props: ['skuString'],
  mounted() {},
  methods: {
    openShareSheet: function() {
      try {
        return navigator.share({
          text: `Someone would like to share their custom LightArt SKU with you: ${this.skuString}`,
        });
      } catch {
        console.warn("Browser does not support share sheet");
      }
    }
  },
  computed: {
    deviceCanShare: function() {
      try {
        return navigator.share;
      } catch {
        return false;
      }
    }
  },
}
</script>
